module.exports = __webpack_public_path__ + "img/img10.8b13306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img10.png
// module id = 250
// module chunks = 0